import { render } from "./VTabsPage.vue?vue&type=template&id=2fec5732&scoped=true&ts=true"
import script from "./VTabsPage.vue?vue&type=script&lang=ts"
export * from "./VTabsPage.vue?vue&type=script&lang=ts"

import "./VTabsPage.vue?vue&type=style&index=0&id=2fec5732&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fec5732"]])

export default __exports__